import { render } from "./waterFall.vue?vue&type=template&id=3ef86a88"
import script from "./waterFall.vue?vue&type=script&lang=js"
export * from "./waterFall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__